export const USER_ABORTED_UPLOAD = 'User aborted upload';

/** Rejected when no upload bytes progress for {@link UPLOAD_STALL_TIMEOUT_MS}. */
export const UPLOAD_STALL_TIMEOUT = 'UPLOAD_STALL_TIMEOUT';

/** Abort stalled single-PUT uploads after this many ms without byte progress. */
export const UPLOAD_STALL_TIMEOUT_MS = 60_000;

export class UploadStatusError extends Error {
  readonly status: number;

  constructor(status: number) {
    super(`Upload failed with status ${status}`);
    this.name = 'UploadStatusError';
    this.status = status;
  }
}

const XHR_DONE_READY_STATE = 4;

export const abortUpload = (xhrRequest: XMLHttpRequest) => {
  if (xhrRequest.readyState < XHR_DONE_READY_STATE) {
    xhrRequest.abort();
  }
};
